<div class="general-settings">
  <h1>{{ 'SETTINGS.GENERAL.TITLE' | translate }}</h1>

  <!-- Tenant Configuration -->
  <div class="general-section">
    <h2>{{ 'SETTINGS.GENERAL.TENANT' | translate }}</h2>

    @let tenantValue = tenant();
    <div class="general-card">
      <div class="card-section">
        @if (tenantLoading()) {
          <div class="loading-container">
            <div class="loading-spinner"></div>
          </div>
        } @else {
          <h3>{{ 'SETTINGS.GENERAL.TENANT_NAME' | translate }}</h3>
          <div class="tenant-display">
            @if (tenantValue) {
              <p class="tenant-name">{{ tenantValue.name }}</p>
            }
            <orbit-button
              [label]="'SETTINGS.GENERAL.EDIT' | translate"
              [icon]="editIcon"
              (onClick)="openTenantDialog()" />
          </div>
        }
      </div>
      <div class="card-section">
        @if (languageLoading()) {
          <div class="loading-container">
            <div class="loading-spinner"></div>
          </div>
        } @else {
          <h3>{{ 'SETTINGS.GENERAL.PREFERRED_LANGUAGE' | translate }}</h3>
          <div class="tenant-display">
            @if (tenantValue) {
              <p class="tenant-language">
                {{ getLanguageDisplayName(tenantValue.preferredLanguage) }}
              </p>
            }
            <orbit-button
              [label]="'SETTINGS.GENERAL.EDIT' | translate"
              [icon]="editIcon"
              (onClick)="openLanguageDialog()" />
          </div>
          <p class="description">{{ 'SETTINGS.GENERAL.LANGUAGE_DESCRIPTION' | translate }}</p>
        }
      </div>
    </div>
  </div>

  <!-- Domains Configuration -->
  <div class="general-section">
    <h2>{{ 'SETTINGS.GENERAL.DOMAINS.TITLE' | translate }}</h2>

    @if (domainsLoading()) {
      <div class="loading-container">
        <div class="loading-spinner"></div>
      </div>
    } @else {
      <!-- System Domains -->
      <div class="general-card">
        <div class="card-section">
          <h3>{{ 'SETTINGS.GENERAL.DOMAINS.SYSTEM.TITLE' | translate }}</h3>
          <p class="description">{{ 'SETTINGS.GENERAL.DOMAINS.SYSTEM.DESCRIPTION' | translate }}</p>

          <div class="domains-list">
            @for (domain of getSystemDomains(); track domain.id) {
              <div class="domain-item">
                <div class="domain-info">
                  <div class="domain-name">{{ domain.domain }}</div>
                  <div class="domain-meta">
                    <div class="domain-type">
                      {{ domain.isClientApp ? ('SETTINGS.GENERAL.DOMAINS.CLIENT_APP.TITLE' | translate) : ('SETTINGS.GENERAL.DOMAINS.MAIN_APP.TITLE' | translate) }}
                    </div>
                    <div class="domain-status status-created">
                      {{ 'SETTINGS.GENERAL.DOMAINS.STATUS_CREATED' | translate }}
                    </div>
                  </div>
                </div>
              </div>
            }
            @empty {
              <div class="empty-state">
                {{ 'SETTINGS.GENERAL.DOMAINS.NO_SYSTEM_DOMAINS' | translate }}
              </div>
            }
          </div>
        </div>
      </div>

      <!-- Custom Domains -->
      <div class="general-card mt-4">
        <div class="card-section">
          <div class="section-header">
            <h3>{{ 'SETTINGS.GENERAL.DOMAINS.CUSTOM.TITLE' | translate }}</h3>
            <div class="section-actions">
              <orbit-button
                variant="secondary"
                [label]="'SETTINGS.GENERAL.DOMAINS.REQUEST' | translate"
                [icon]="plusIcon"
                (onClick)="openAddDomainDialog(customDomainType)"
                [disabled]="hasCustomDomain(true) && hasCustomDomain(false)"
              ></orbit-button>
            </div>
          </div>
          <p class="description">{{ 'SETTINGS.GENERAL.DOMAINS.CUSTOM.DESCRIPTION' | translate }}</p>

          <!-- Custom Domains List -->
          <div class="domains-list">
            @let customDomains = getCustomDomains();
            @for (domain of customDomains; track domain.id) {
              <div class="domain-item">
                <div class="domain-info">
                  <div class="domain-name">{{ domain.domain }}</div>
                  <div class="domain-meta">
                    <div class="domain-type">
                      {{ domain.isClientApp ? ('SETTINGS.GENERAL.DOMAINS.CLIENT_APP.TITLE' | translate) : ('SETTINGS.GENERAL.DOMAINS.MAIN_APP.TITLE' | translate) }}
                    </div>
                    <div class="domain-status" [ngClass]="getDomainStatusClass(domain.status)">
                      {{ getDomainStatusText(domain.status) }}
                    </div>
                  </div>
                </div>
                <div class="domain-actions">
                  @if (domain.status === 'REQUESTED' || domain.status === 'CREATED') {
                    <orbit-button
                      variant="secondary"
                      size="small"
                      [icon]="editIcon"
                      [title]="'SETTINGS.GENERAL.DOMAINS.UPDATE' | translate"
                      (onClick)="updateDomain(domain)"
                    ></orbit-button>
                  }
                  @if (domain.status !== 'DELETE_REQUESTED') {
                    <orbit-button
                      variant="danger"
                      size="small"
                      [icon]="trashIcon"
                      [title]="'SETTINGS.GENERAL.DOMAINS.DELETE.TITLE' | translate"
                      (onClick)="deleteDomain(domain)"
                    ></orbit-button>
                  }
                </div>
              </div>
            }
            @empty {
              <div class="empty-state">
                {{ 'SETTINGS.GENERAL.DOMAINS.NO_CUSTOM_DOMAINS' | translate }}
                <p>{{ 'SETTINGS.GENERAL.DOMAINS.REQUEST_CUSTOM_DOMAIN_HINT' | translate }}</p>
              </div>
            }
          </div>
        </div>
      </div>
    }
  </div>
</div>
